{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "회원님의 역할로는 다음 작업을 수행할 수 없습니다: {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "회원님의 역할로는 이 작업을 수행할 수 없습니다",
    "mustHaveAtLeast8Characters": "8자 이상이어야 합니다",
    "mustContainUpperCaseAndLowerCase": "대문자와 소문자를 포함해야 합니다",
    "mustContainAtLeastOneLetter": "문자를 하나 이상 포함해야 합니다",
    "mustContainAtLeastOneSpecialCharacter": "특수 문자를 하나 이상 포함해야 합니다",
    "mustContainAtLeastOneNumber": "숫자를 하나 이상 포함해야 합니다"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "모든 계정에 대한 모든 권한 및 전체 제어 권한.",
    "godRoleWithLessControl": "제어 권한이 제한된 최고 관리자 역할.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "조직 계정에 대한 모든 권한 및 전체 제어 권한.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "예약, 창고, 화물 유형, 도크 및 사용자(소유자 제외) 생성/편집/삭제.",
    "createEditCancelAppointments": "예약 생성/편집/취소.",
    "editAppointmentStatusTagsAndSubscribers": "예약 상태, 태그 및 수신자 편집.",
    "viewOnlyNoCreateOrEditActionsAllowed": "보기 전용. 생성 또는 편집 작업을 할 수 없습니다.",
    "carrierAdministrator": "운송사 관리자.",
    "carrierUser": "운송사 사용자",
    "baseUserAccount": "기본 사용자 계정.",
    "warehouseDriverHasLimitedAccessToTheApplication": "창고 운전자. 애플리케이션 접근이 제한됩니다."
  }
}
